const Host = "https://api.patliputraanokhihomes.com"
// const Host = "http://localhost:8000"
export default Host;